import React from 'react';

const Dashboard = () => {
    return (
        <div className='w-full border-b border-solid border-stone-200 h-screen mt-4 ml-4'>
            <div
                className="block p-6 ml-[-5px] mr-2 my-2 w-[95%] bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700"
            >
                <h1 className='text-center px-4 py-4 text-5xl sm:text-xl md:text-2xl lg:text-3xl font-bold'>
                    Selamat Datang di Halaman Dashboard
                </h1>
                <div className='w-[85%] h-[100%] mx-auto'>
                    <img src='https://media.istockphoto.com/vectors/analytics-optimization-desktop-dashboard-blue-flat-design-vector-id1253822466?k=20&m=1253822466&s=612x612&w=0&h=YvIFa6pUQ13RGg1l406YzThaxM7wDGSCQOaBcy3qcwA=' alt='' />
                </div>
            </div>

        </div>
    )
}

export default Dashboard;
